import { GraphQLList, GraphQLObjectType, GraphQLString } from 'graphql';

import { TypeNames } from '../../types';

const MutabilityConstraints = new GraphQLObjectType({
	fields: {
		field: { type: GraphQLString },
		reason: { type: GraphQLString },
	},
	name: TypeNames.USER_DETAILS_MUTABILITY_CONSTRAINTS,
});

const UserManageConfig = new GraphQLObjectType({
	fields: {
		mutabilityConstraints: {
			type: new GraphQLList(MutabilityConstraints),
		},
	},
	name: TypeNames.USER_MANAGE_CONFIG,
	description: 'User mutability constraints values',
});

export default UserManageConfig;
